import React from 'react';
// tried to use rc-slider, but issues creating build on server
import ReactSlider from 'react-slider';
import styled from 'styled-components';

import colors from '@general/colors';

const StyledSlider = styled(ReactSlider)`
    width: 100%;
    height: 4px;
    display: flex;
    align-items: center;
`;

const StyledThumb = styled.div`
    height: 14px;
    line-height: 14px;
    width: 14px;
    text-align: center;
    border-radius: 50%;
    cursor: grab;
    background-color: #fff;
    border: solid 2px ${colors.primary};
`;

const Thumb = (props, state) => <StyledThumb {...props} />;

const StyledTrack = styled.div`
    top: 0;
    bottom: 0;
    border-radius: 6px;
    background: ${props => (props.index === 2 ? '#f00' : props.index === 1 ? colors.lightGray : colors.primary)};
`;

const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

const Slider = props => <StyledSlider {...props} renderTrack={Track} renderThumb={Thumb} />;

export default Slider;
